module.exports = __webpack_public_path__ + "img/dk.d4f02e61.svg";